import { zafClient } from '@/services/zendesk'
import type { VtexOrder, ZafMetadata, TotalExpressResponse } from '@/interfaces'

export async function getTotalExpressTracking(order: VtexOrder): Promise<TotalExpressResponse> {
  if (!zafClient) throw new Error('ZAF client not available')

  const meta = await zafClient.metadata() as unknown as ZafMetadata
  const user = meta.settings['total-express-user']
  const password = meta.settings['total-express-password']

  if (!user || !password) throw new Error('Credenciais Total Express não configuradas')

  const invoiceNumber = order.packageAttachment.packages[0]?.invoiceNumber
  if (!invoiceNumber) throw new Error('Número da nota fiscal não encontrado no pedido')

  const credentials = btoa(`${user}:${password}`)

  const response = await zafClient.request({
    url: 'https://apis.totalexpress.com.br/ics-tracking-encomenda-lv/v1/tracking',
    type: 'POST',
    headers: {
      Authorization: `Basic ${credentials}`,
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ notasFiscais: [invoiceNumber], comprovanteEntrega: false }),
    dataType: 'json',
    contentType: 'application/json',
  }) as TotalExpressResponse

  return response
}
